import React from 'react';

import { ReactComponent as EmergeIcon } from '@/assets/EmergeLogoV2.svg';
import { ReactComponent as EmergeName } from '@/assets/EmergeName.svg';
import { openLinkInSameTab } from '@/utils/openLinkInSameTab';
import { EMERGE_WEBSITE } from '@/utils/externalLinks';
import cn from '@/utils/cn';

interface EmergeLogoProps {
  showName?: boolean;
  className?: string;
}

function EmergeLogo({ showName = true, className }: EmergeLogoProps) {
  return (
    <div
      className={cn('flex flex-row items-center gap-x-3 cursor-pointer', className)}
      onClick={() => openLinkInSameTab(EMERGE_WEBSITE)}>
      <EmergeIcon />
      {showName && <EmergeName />}
    </div>
  );
}

export default EmergeLogo;
